/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_Send_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to send verification email" |
*
* @param {Profile_Email_Send_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_send_failed = /** @type {((inputs?: Profile_Email_Send_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_Send_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'envoi de l'email de vérification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al enviar el email de verificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao enviar email de verificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio dell'email di verifica non riuscito")
	return /** @type {LocalizedString} */ ("Failed to send verification email")
});